import React from 'react';

import CourseOpenIcon from 'assets/icons/course-open.svg';
import TimeCounter from '@core/components/timecounter/TimeCounter';
import LinkButton from '@core/components/linkbutton/LinkButton';

import classes from './FreeCourseLimitation.module.scss';


const FreeCourseLimitation = ({time}) => {
    return (
        <div className={classes['wrapper']}>
            <div className='d-flex flex-wrap align-items-center gap-4 justify-content-center mb-4 mb-md-0'>
                <div className='d-flex gap-2 align-items-center justify-content-center'>
                    <CourseOpenIcon />
                    <h5>Your next free course unlocks in</h5>
                </div>
                <TimeCounter time={time} />
            </div>
            <LinkButton to={'/plans'}   >
                Unlock All Courses Now
            </LinkButton>
        </div>
    );
};

export default FreeCourseLimitation;